export default __webpack_public_path__ + "static/media/My project.170c9598.jpg";